// Раскладка ленты провалов судна: период в одну полоску, провалы на своих местах.
//
// Смысл ленты — увидеть РИТМ молчания (редкие длинные против частых коротких),
// а не только сумму часов. Поэтому провал стоит там, где случился, и обрезается
// по краям периода, а не вылезает за полосу.

import type { ObsGap } from '../api'

export interface RibbonSegment {
  leftPct: number
  widthPct: number
  gap: ObsGap
}

// Минимальная видимая ширина сегмента, % полосы. Двадцатиминутный провал на
// десятисуточной ленте — 0.14 %: без пола он исчезнет, и лента соврёт «чисто».
const MIN_WIDTH_PCT = 0.4

export function ribbonSegments(
  gaps: ObsGap[],
  from: string,
  to: string,
): RibbonSegment[] {
  const start = Date.parse(from)
  const end = Date.parse(to)
  const span = end - start
  if (!Number.isFinite(span) || span <= 0) return []

  const segments: RibbonSegment[] = []
  for (const gap of gaps) {
    const gapStart = Date.parse(gap.start)
    const gapEnd = Date.parse(gap.end)
    // Полностью вне периода — не наш случай (провал мог начаться до окна).
    if (gapEnd <= start || gapStart >= end) continue

    const clampedStart = Math.max(gapStart, start)
    const clampedEnd = Math.min(gapEnd, end)
    const leftPct = ((clampedStart - start) / span) * 100
    const rawWidth = ((clampedEnd - clampedStart) / span) * 100
    // Пол ширины не должен выталкивать сегмент за правый край полосы.
    const widthPct = Math.min(Math.max(rawWidth, MIN_WIDTH_PCT), 100 - leftPct)
    segments.push({ leftPct, widthPct, gap })
  }
  return segments
}
